import { useEffect } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

export default function PoliticaPrivacidade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-white">
      <title>Política de Privacidade | Clientizah</title>
      <meta name="robots" content="noindex, follow" />
      <Navbar />
      <main className="pt-[160px] pb-20">
        {/* Header */}
        <section className="py-14 px-6 md:px-16 bg-[#f9f8f6] border-b border-gray-100">
          <div className="max-w-4xl mx-auto">
            <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-3">Legal</p>
            <h1 className="text-4xl font-light text-black tracking-tight mb-3">Política de Privacidade</h1>
            <p className="text-gray-400 text-xs tracking-wide">Última atualização: março de 2025</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-14 px-6 md:px-16">
          <div className="max-w-4xl mx-auto space-y-10 text-sm text-gray-600 leading-relaxed">

            <div>
              <h4 id="introducao"><a className="text-black font-semibold text-base tracking-tight">1. Introdução</a></h4>
              <p className="mt-3">
                A <strong>Clientizah</strong>, por meio de sua plataforma e cursos online, respeita a privacidade de seus usuários e está comprometida com a proteção dos dados pessoais coletados durante o uso de nossos serviços. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações, em conformidade com a <strong>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
              </p>
            </div>

            <div>
              <h4 id="dados-coletados"><a className="text-black font-semibold text-base tracking-tight">2. Dados que coletamos</a></h4>
              <p className="mt-3">Podemos coletar as seguintes informações:</p>
              <ul className="mt-3 space-y-2 list-none">
                {[
                  "Nome completo",
                  "Endereço de e-mail",
                  "Número de telefone / WhatsApp",
                  "Dados de pagamento (processados por terceiros seguros — nunca armazenados por nós)",
                  "Informações de uso da plataforma (páginas visitadas, tempo de acesso)",
                  "Dados fornecidos em formulários de inscrição e contato",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-checkbox-blank-circle-fill text-[#b8962e] text-[6px]"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 id="uso-dados"><a className="text-black font-semibold text-base tracking-tight">3. Como usamos seus dados</a></h4>
              <p className="mt-3">Suas informações são utilizadas exclusivamente para:</p>
              <ul className="mt-3 space-y-2 list-none">
                {[
                  "Processar sua inscrição e liberar acesso aos cursos",
                  "Enviar comunicações sobre seu pedido, acesso e novidades",
                  "Oferecer suporte e atendimento personalizado",
                  "Melhorar nossa plataforma e conteúdo com base no comportamento de uso",
                  "Cumprir obrigações legais e regulatórias",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-checkbox-blank-circle-fill text-[#b8962e] text-[6px]"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 id="compartilhamento"><a className="text-black font-semibold text-base tracking-tight">4. Compartilhamento de dados</a></h4>
              <p className="mt-3">
                Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins comerciais. Podemos compartilhar informações apenas com parceiros essenciais para a operação dos nossos serviços (ex: plataforma de pagamento, hospedagem de vídeo), sempre sob acordos de confidencialidade e em conformidade com a LGPD.
              </p>
            </div>

            <div>
              <h4 id="cookies"><a className="text-black font-semibold text-base tracking-tight">5. Cookies</a></h4>
              <p className="mt-3">
                Utilizamos cookies para melhorar sua experiência de navegação, salvar preferências e analisar o tráfego do site. Você pode desativar os cookies nas configurações do seu navegador, mas isso pode limitar algumas funcionalidades da plataforma.
              </p>
            </div>

            <div>
              <h4 id="seguranca"><a className="text-black font-semibold text-base tracking-tight">6. Segurança dos dados</a></h4>
              <p className="mt-3">
                Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados contra acesso não autorizado, perda, destruição ou divulgação. Nossas plataformas utilizam criptografia SSL e seguem as melhores práticas de segurança digital.
              </p>
            </div>

            <div>
              <h4 id="direitos"><a className="text-black font-semibold text-base tracking-tight">7. Seus direitos</a></h4>
              <p className="mt-3">Nos termos da LGPD, você tem direito a:</p>
              <ul className="mt-3 space-y-2 list-none">
                {[
                  "Confirmar a existência de tratamento dos seus dados",
                  "Acessar seus dados pessoais",
                  "Corrigir dados incompletos, inexatos ou desatualizados",
                  "Solicitar a anonimização, bloqueio ou eliminação dos seus dados",
                  "Revogar o consentimento dado a qualquer momento",
                  "Solicitar a portabilidade dos seus dados",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-checkbox-blank-circle-fill text-[#b8962e] text-[6px]"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 id="retencao"><a className="text-black font-semibold text-base tracking-tight">8. Retenção de dados</a></h4>
              <p className="mt-3">
                Mantemos seus dados pelo tempo necessário para prestação do serviço contratado e pelo prazo exigido por obrigações legais. Após esse período, os dados são eliminados de forma segura.
              </p>
            </div>

            <div>
              <h4 id="contato"><a className="text-black font-semibold text-base tracking-tight">9. Contato</a></h4>
              <p className="mt-3">
                Para exercer seus direitos ou esclarecer dúvidas sobre esta política, entre em contato conosco:
              </p>
              <div className="mt-4 bg-[#f9f8f6] border border-gray-100 p-6 space-y-2">
                <p><strong className="text-black">Clientizah</strong></p>
                <p>E-mail: <a href="mailto:suporte@clientizah.com.br" className="text-[#b8962e] hover:underline">suporte@clientizah.com.br</a></p>
                <p>WhatsApp: <a href="https://wa.me/5511981969885" target="_blank" rel="nofollow noopener noreferrer" className="text-[#b8962e] hover:underline">(11) 98196-9885</a></p>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-100">
              <p className="text-gray-400 text-xs">
                Esta política pode ser atualizada periodicamente. Recomendamos que você a consulte regularmente. O uso continuado dos nossos serviços após qualquer alteração implica aceitação das mudanças.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
